export const IS_DEV = import.meta.env.DEV;
export const IS_PROD = import.meta.env.PROD;
export const MODE = import.meta.env.MODE;

// Parse the environment variable string 'true' into a boolean
// This allows you to control it via .env.development
export const TEST_REAL_API = import.meta.env.VITE_TEST_REAL_API === 'true';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;